import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

// Link to the homepage that always lands at the top. From another page the
// route change scrolls up (SiteLayout's ScrollManager); on the homepage itself
// it smooth-scrolls up and drops any #section from the URL.
export default function HomeLink({ onClick, children, ...props }) {
    const { pathname, hash } = useLocation();
    const navigate = useNavigate();

    const handleClick = (e) => {
        onClick?.(e);
        if (pathname !== '/') return;
        e.preventDefault();
        if (hash) {
            navigate('/', { replace: true, state: { smoothTop: true } });
        } else {
            // Next frame, so a closing mobile menu has released the scroll lock.
            requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
        }
    };

    return <Link to="/" onClick={handleClick} {...props}>{children}</Link>;
}
